<template>
  <template v-for="e in evaluations" :key="`evaluations${e.id}`">
    <div class="wbg pd16 colFlex brd16 mt16">
      <nut-rate active-color="orange" icon-size="30"
                checked-icon="https://cdn.waityou.online/a7daaf55-aeae-d157-9eb6-e9554fdeb5f7.png"
                unchecked-icon="https://cdn.waityou.online/6caf8edf-e720-47fa-8652-976426ee5b62.png"
                v-model="e.score"/>
      <nut-row class="bothCenter mt16">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">评价时间</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ e.evaluateTime }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter mt16">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">评价用户</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ desensitize.desensitizeChineseName(e.userName) }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter mt16">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">用户评价</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ e.content }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="colFlex mt16" v-if="e.imgs && e.imgs.length > 0">
        <span class="smallFont" style="color:#999999;">评价配图</span>
        <nut-row class="leftCenter mt6" style="flex-wrap: wrap">
          <photo-provider>
            <template v-for="img in e.imgs" :key="img">
              <div class="sqr64 mr12 mb12">
                <photo-consumer :src="img" style="text-align: left;width: 100%">
                  <img :src="`${img}?x-oss-process=image/resize,p_30`" class="sqr64 brd6">
                </photo-consumer>
              </div>
            </template>
          </photo-provider>
        </nut-row>
      </nut-row>
    </div>
  </template>
</template>

<script>
import desensitize from "../../utils/desensitize";

export default {
  name: "UserEvaluation",
  components: {},
  computed: {
    desensitize() {
      return desensitize
    }
  },
  props: {
    evaluations: {
      type: Array,
      default: ()=>{
        return []
      }
    },
  },
  data() {
    return {}
  },
  methods: {
    init() {
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.UserEvaluationContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;
}
</style>